export default {"src":"/org/_next/static/media/spot.5a580baf.svg","height":13,"width":18,"blurWidth":0,"blurHeight":0};